import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import MealSiblingsQuery from './MealSiblingsQuery';

const MealSiblingsConnectorApollo = ({ children, date }) => {
  const { loading, error, data } = useQuery(MealSiblingsQuery, {
    variables: {
      date,
    },
  });

  const result = {
    loading,
    error,
  };

  if (!loading) {
    result.dailyDietPlan = data.me.dailyDietPlan;
  }

  return children(result);
};

MealSiblingsConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
};

export default MealSiblingsConnectorApollo;
